{
    "name": "@rigstate/cli",
    "version": "0.7.40",
    "description": "Rigstate CLI - Code audit, sync and supervision tool",
    "type": "module",
    "main": "./dist/index.js",
    "bin": {
        "rigstate": "dist/index.js"
    },
    "scripts": {
        "dev": "tsup --watch",
        "build": "tsup",
        "lint": "tsc --noEmit",
        "start": "node dist/index.js",
        "test": "node dist/index.js --help"
    },
    "dependencies": {
        "@rigstate/rules-engine": "^0.6.1",
        "@rigstate/shared": "^0.7.3",
        "@types/diff": "^7.0.2",
        "@types/inquirer": "^9.0.9",
        "axios": "^1.6.5",
        "boxen": "^8.0.1",
        "chalk": "^5.3.0",
        "chokidar": "^3.6.0",
        "commander": "^12.0.0",
        "conf": "^12.0.0",
        "diff": "^4.0.2",
        "dotenv": "^16.4.1",
        "glob": "^10.3.10",
        "ink": "^6.8.0",
        "ink-spinner": "^5.0.0",
        "ink-text-input": "^6.0.0",
        "inquirer": "^9.3.8",
        "ora": "^8.0.1",
        "react": "^19.2.3",
        "simple-git": "^3.31.1",
        "uuid": "^9.0.1"
    },
    "devDependencies": {
        "@types/node": "^20.11.5",
        "@types/react": "^19.2.14",
        "@types/uuid": "^10.0.0",
        "tsup": "^8.0.1",
        "typescript": "^5.3.3"
    },
    "engines": {
        "node": ">=18.0.0"
    },
    "keywords": [
        "rigstate",
        "cli",
        "audit",
        "security",
        "code-quality",
        "supervisor"
    ],
    "author": "Rigstate",
    "license": "MIT",
    "publishConfig": {
        "access": "public"
    }
}